module.exports = __webpack_public_path__ + "files/8cc60fd5985fceea2e8c7cbadb731eaf.ttf";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/katex/dist/fonts/KaTeX_Size1-Regular.ttf
// module id = 1411
// module chunks = 59